import { DefaultFooter } from '@ant-design/pro-components'

function Footer() {
  const currentYear = new Date().getFullYear()
  return <DefaultFooter copyright={`${currentYear} 哒可哒可`} links={[]} />
}

export default Footer
